import { useOutletContext } from "react-router-dom";
import WebsiteTable from "../Website/WebsiteTable";

const Webistes = () => {
    const { user, admin: isAdmin } = useOutletContext();
    return (
        <div className="mt-6">
            <WebsiteTable user={user} isAdmin={isAdmin} />
        </div>
    );
};

export default Webistes;
